import React from 'react';
import AddTags from './AddTags';
import AddCourse from './AddCourse';
import AddLessons from './AddLessons';
import AddTeacher from './AddTeacher';
import AddPackage from './AddPackage';
import AddFaculty from './AddFaculty';
import AddAcademic from './AddAcademic';
import FinalTest from './FinalTest';
import AddUserSubscription from './AddUserSubscription';

import { useTranslation } from 'react-i18next';

function AdminDashBoard() {
	const { t } = useTranslation();
	const [activeComponent, setActiveComponent] = React.useState(<AddTags />);
	const [activeIndex, setActiveIndex] = React.useState(0);
	const menuItems = [
		{ name: t('tags'), component: <AddTags /> },
		{ name: t('usersSubscription'), component: <AddUserSubscription /> },
		{ name: t('teachers'), component: <AddTeacher /> },
		{ name: t('courses'), component: <AddCourse /> },
		{ name: t('lessons'), component: <AddLessons /> },
		{ name: t('packages'), component: <AddPackage /> },
		{ name: t('faculty'), component: <AddFaculty /> },
		{ name: t('academic'), component: <AddAcademic /> },
		{ name: t('finalTest'), component: <FinalTest /> },
	];
	return (
		<div className='dashboard-container text-white flex flex-col md:flex-row gap-6'>
			<div className='sidebar w-full md:w-3/12 h-auto'>
				<ul className='h-full bg-section  flex-row gap-4 p-4 flex flex-wrap md:flex-col mt-32'>
					{menuItems.map((item, index) => (
						<li
							key={index}
							className={`p-2 cursor-pointer w-fit md:flex-grow-0 md:w-full border-main border border-solid rounded-md md:hover:cursor-pointer text-main md:hover:bg-secondary md:hover:border-secondary transition-all duration-300 ${
								activeIndex === index
									? 'text-white bg-secondary border-secondary'
									: ''
							}`}
							onClick={() => {
								setActiveComponent(item.component);
								setActiveIndex(index);
							}}>
							{item.name}
						</li>
					))}
				</ul>
			</div>

			<div className='w-full'>{activeComponent}</div>
		</div>
	);
}

export default AdminDashBoard;
